import { IonDate } from "../i-components/IonDate.tsx";
const CheckNotNull = Symbol("CheckNotNull");

class EventItem {
    public itemID: string = '';
    public eventID: string = '';
    public base_url: string = '';
    public file_names: string[] = [] as string[];
    public datetime_expired: Date[] | null[] = [] as any[];
    public type: number = 0;

    constructor(
        itemID: string,
        eventID: string,
        base_url: string,
        file_names: string,
        datetime_expired: string,
        type: string
    ) {
        this.itemID  = this[CheckNotNull](itemID) ? itemID : ''; 
        this.eventID  = this[CheckNotNull](eventID) ? eventID : ''; 
        this.base_url  = this[CheckNotNull](base_url) ? base_url : ''; 
        this.file_names  = this[CheckNotNull](file_names) ? file_names.split(',') : []; 
        this.datetime_expired = this[CheckNotNull](datetime_expired) ? datetime_expired.split(',').map((dateTimeString: string) => dateTimeString != 'null' ? IonDate(dateTimeString) : null) : [] as any[];
        this.type = this[CheckNotNull](type) ? parseInt(type) : 0;
    }

    public RemoveExpiredAttachments = () => {
        if(this.datetime_expired.length > 0) {
            //remove expired attachments
            const newFileNames = [] as string[];
            const newDateTimeExpired = [] as any[];

            this.datetime_expired.map((dateTimeExpired: any, i: number) => {
                if(
                    dateTimeExpired == null
                    || new Date() <= dateTimeExpired
                ) {
                    newFileNames.push(this.file_names[i]);
                    newDateTimeExpired.push(this.datetime_expired[i]);
                }
            });
            this.file_names = newFileNames;
            this.datetime_expired = newDateTimeExpired;
        }
    }

    private [CheckNotNull] = (value: string) => {
        if(value != undefined && value && value != null && value != 'null' && value.length > 0) {
            return true;
        }
        else
            return false;
    }
}
export default EventItem;